import { TrackingClient } from "@sparefoot/tracking-client";

// TODO: ADD STORE back to initial destructuring
const readyMiddleware = (store) => (next) => (action) => {
	/**
	 * This is middleware for doing things once the app has initialized.
	 * A useEffect in ApplicationWrapper calls the setAppReady action.
	 */
	if (action.type === "app/setAppReady") {
        const { experiments } = store.getState();
		
        // Only fire event if experiments are active/loaded and relevant for the loaded page
        if (experiments && typeof window !== "undefined" && experiments?.loaded) {
            Object.entries(experiments?.bucket).forEach(([experimentName, experimentVariation]) => {

                TrackingClient.trackExperimentView({
                    category: experimentName,
                    label: `Phlag ${experimentName} ${experimentVariation}`,
                    experiment_source: "Phlag",
                    experiment_id: experimentName,
                    variant_id: experimentVariation
                });
            });
        }
	}
	return next(action);
};

export default readyMiddleware;
